import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ErrorService } from "@services/error.service";
import { NotificationService } from "@services/notification.service";
import { environment } from "@env/environment";
import { map, tap } from "rxjs/operators";
import {ApiResponse, ServicesResponse} from "@core/model/servicesResponse";

@Injectable({
  providedIn: 'root'
})
export class ForcePasswordService {
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
    private notificationService: NotificationService
  ) { }

  sendPasswordChangeNotfification(request): Observable<ServicesResponse> {
    this.isLoading$.next(true);
    return this.http.post<ApiResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/passwordChangeNotification`, request)
      .pipe(
        tap(response => {
          this.isLoading$.next(false);
          if (response.status.codice !== '000') {
            const errorMessage = "Si è verificato un errore in fase di invio della notifica di modifica della password.";
            this.errorService.setError(errorMessage);
            throw new Error(errorMessage);
          } else {
            this.notificationService.setNotification("Notifica inviata con successo.");
          }
        }),
        map(response => response)
      )
  }
}
